export const ignoreErrors = [
	/AsyncLocalStorage/,
	/resizeobserver loop/i,
	/transition was (aborted|skipped)/i,
	/view transition/,
	'Attempted to assign to readonly property',
	/This tee time is no longer available/,
	/Invalid `prisma\./i,
	/fetch is aborted/i,
	/failed to fetch/i,
	/(load|fetch) failed/i,
];
